import dayjs from "dayjs";
import { Component, OnInit, inject, output } from "@angular/core";
import { IFilterSelection } from "../../../../../core-ui/models/interfaces";
import { AgentParam } from "../../../../../core-ui/models/application-options/AgentOptions";
import { AppConfigService } from "../../../../../core-ui/services/app.config.service";

@Component({
  selector: "app-duration-filter",
  templateUrl: "./duration-filter.component.html",
  styleUrls: ["./duration-filter.component.scss"],
  standalone: false,
})
export class DurationFilterComponent implements OnInit {
  private config = inject(AppConfigService);

  readonly changed = output<string[]>();

  durations: number[] = [];
  selection: number[] = [];

  ngOnInit(): void {
    this.durations = this.config
      .agentParam(AgentParam.APPOINTMENT_DURATION_OPTIONS)
      .sort((a, b) => a - b);
  }

  selectionChanged(filter: IFilterSelection<number>) {
    this.selection = filter.checked
      ? [...this.selection, filter.value]
      : this.selection.filter((s) => s !== filter.value);
    this.changed.emit(
      this.selection.map((s) => dayjs.duration(s, "minutes").toISOString())
    );
  }
}
